import { render, staticRenderFns } from "./EstimageMessageView.vue?vue&type=template&id=81b9166a"
import script from "./EstimageMessageView.vue?vue&type=script&lang=js"
export * from "./EstimageMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports